import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { TaxonomyModule } from '@app/modules/taxonomy/taxonomy.module';
import { AddArticleModalComponent } from './add-article-modal.component';
import { AddArticleComponent } from './add-article.component';
import { ArticleFormComponent } from './article-form/article-form.component';
import { ArticleContainerComponent } from './article-container/article-container.component';

@NgModule({
    declarations: [AddArticleComponent, AddArticleModalComponent, ArticleFormComponent, ArticleContainerComponent],
    imports: [CommonModule, SharedModule, TaxonomyModule],
    exports: [AddArticleComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AddArticleModule {}
